export default __webpack_public_path__ + "static/media/0x7cb0c805544c5ba83a6e014a9e199e1c8ed16137.673c4983.png";